import { useContext } from "react";

import { logger as baseLogger } from "@core/logger";

import { ApiContext } from "../index";

const logger = baseLogger.getSubLogger({ name: "ApiHooks" });

/**
 * Hook for accessing the full API context.
 */
export function useApiContext() {
  const context = useContext(ApiContext);
  if (!context) {
    logger.error("useApiContext must be used within an ApiProvider");
    if (process.env.NODE_ENV === "development") {
      throw new Error("useApiContext must be used within an ApiProvider");
    }
  }
  return context;
}

/**
 * Hook for accessing the Data API client.
 * Returns the ISharedDataApi interface implementation provided by the app.
 * @returns ISharedDataApi implementation (PropAIApi for propai-web, PlatformDataApi for platform-web)
 */
export function useDataApi() {
  const context = useApiContext();
  if (!context?.dataApi) {
    console.debug("[useDataApi] Data API not yet initialized");
    return null;
  }
  return context.dataApi;
}

/**
 * Hook for accessing the Weather API client.
 */
export function useWeatherApi() {
  const context = useApiContext();
  if (!context?.weatherApi) {
    throw new Error("Weather API is not available");
  }
  return context.weatherApi;
}
